import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import {initTheme} from '@/theme/themeStorage';
import '@/i18n/i18n';
import './reset.css';
import './tailwind.css';
import './Sentry';

initTheme();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
